import * as XLSX from "xlsx-js-style";

const exportToSage = (data = [], fileName = "export",i18n) => {
  const formatDate = (dateValue) => {
    if (!dateValue) return "";
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return "";

    return `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${date.getFullYear()}`;
  };

  const entradasData = data.flatMap((item) => {
     const formatted_id = item.ownshipping_id.toString().padStart(8, '0');
    const albaranDetails = [
      "SF",
      formatted_id || "",
      item.dest_tras_accountingentry || "",
      formatDate(item.date_shipping),
    ];
    const lines = Array.isArray(item.linesshipping) ? [...item.linesshipping] : [];
    return lines.map((line) => {
      const amount = Number(line.amount) || 0;
      const estimatedprice = Number(line.estimatedprice) || 0;
      const discount = Number(line.discount) || 0;
      return [
        ...albaranDetails,
        "00000000",
        String(line.paymenttype_code || 1).padStart(2, "0"),
        String(item.vehiclestore_defaultdriver || 1).padStart(2, "0"),
        line.article_code || "", 
        amount,
        estimatedprice, 
        discount,
        0, 
        line.article_namees || "", 
      ];
    });
  });

  const headers = [
    "SERIE",
    "ALBARAN",
    "CLIENTE",
    "FECHA",
    "ALMACEN",
    "FORMAPAGO",
    "VENDEDOR",
    "ARTICULO",
    "UNIDADES",
    "PRECIO", 
    "DTO1",
    "DTO2", 
    "DEFINICION"
  ];

  const entradasWorksheet = XLSX.utils.aoa_to_sheet([headers, ...entradasData]);

  const range = XLSX.utils.decode_range(entradasWorksheet["!ref"]);

  const numericColumns = [8];
  const decimalColumns = [9, 10, 11];

  for (let row = 1; row <= range.e.r; row++) {
    for (let col of numericColumns) {
      const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
      const cell = entradasWorksheet[cellAddress];
      if (!cell) continue;
      if (cell.v !== "" && cell.v !== null && cell.v !== undefined) {
        cell.t = "n";
        cell.v = Number(cell.v) || 0;
      }
    }
    for (let col of decimalColumns) {
      const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
      const cell = entradasWorksheet[cellAddress];
      if (!cell) continue;
      if (cell.v !== "" && cell.v !== null && cell.v !== undefined) {
        cell.t = "n";
        cell.v = Number((Number(cell.v) || 0).toFixed(2));
        cell.z = "0.00";
      }
    }
  }

  entradasWorksheet["!cols"] = [
    { wch: 14 },//"SERIE",
    { wch: 18 },//"ALBARAN",
    { wch: 18 },//"ASIENTO CONTABLE",
    { wch: 18 },//"FECHA",
    { wch: 18 },//"CÓDIGO ALMACÉN",
    { wch: 18 },// "CÓDIGO FORMA DE PAGO",
    { wch: 18 },//"VENDEDOR",
    { wch: 18 },//"CÓDIGO ARTÍCULO",
    { wch: 16 },////"UNIDADES",
    { wch: 16 },// "PRECIO",
    { wch: 16 },//"DTO1",
    { wch: 16 },//"DTO2", 
    { wch: 30 },//"DEFINICION", 
  ];

  const workbook = XLSX.utils.book_new();
  const safeFileName = fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`;

  XLSX.utils.book_append_sheet(workbook, entradasWorksheet, "CARTAS DE PORTES A SAGE");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = safeFileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export default exportToSage;
